import React, { useState, useEffect } from 'react';
import Select from 'react-select';  // 引入 react-select
import { api_url, loginInfo } from "../globalFunction/global_string";

const SelectTenableUnit = ({ id, name, requiredAPI, handleUnitSelectChange, selectnet, local_net_name, value, selectedunit }) => {
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);


  useEffect(() => {
    if (selectnet && local_net_name) {
      loadData();
    }
  }, [selectnet, local_net_name]);

  useEffect(() => {
    if (selectedunit && options.length > 0) {
      const selectedOption = options.find(option => option.value === selectedunit);
      setSelectedValue(selectedOption || null);
    }
  }, [selectedunit, options]);


  const loadData = () => {
    let apiUrl = api_url + requiredAPI;
    const formData = new FormData();

    switch (localStorage.getItem('login_user_type')) {
      case "S":
        formData.append("local_net_id", selectnet);
        formData.append("local_net_name", local_net_name);
        break;
      case "M":
        formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
        formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
        break;
      default:
        break;
    }

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        const rows = Array.isArray(data.row) ? data.row : [data.row];
        const formattedOptions = rows.map(option => ({
          value: option.local_unit_id,
          label: option.local_unit_name
        }));
        setOptions(formattedOptions);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  const handleSelectChange = (selectedOption) => {
    setSelectedValue(selectedOption);  // 更新選擇的值
    handleUnitSelectChange({
      name,
      value: selectedOption ? selectedOption.value : '',
      selectedName: selectedOption ? selectedOption.label : ''
    });
  };

  return (
    <Select
      id={id}
      name={name}
      value={selectedValue}
      onChange={handleSelectChange}
      options={options}
      isSearchable  // 使選單可搜尋
      placeholder="請選擇單位"
    />
  );
};

export default SelectTenableUnit;
